// components
import DisplayValue from "../DisplayValue";
import SBACertificateCard from "./SBACertificateCard";

// store
import { useSearchStore } from "store/searchStore";

// assets
import SBACertBadge from "assets/images/sba-badge.png";

// styles
import styles from "./ProfileCertifications.module.scss";

function getCurrentSBACerts(certs) {
  return certs.filter(x => x.active && !x?.pending);
}

function getPendingSBACerts(certs) {
  return certs.filter(x => x?.pending);
}

function getPastSBACerts(certs) {
  return certs.filter(x => !x.active && !x?.suspended && !x?.pending);
}

function getSuspendedSBACerts(certs) {
  return certs.filter(x => x.suspended)
}

export default function ProfileCertifications() {
  const {
    business_profile: { certs, non_fed_govt_certifications },
  } = useSearchStore();

  const certNotShowingInSAM = {
    display: "SBA certification not visible in SAM.gov?",
    link: "https://sbaone.atlassian.net/wiki/external/MDMwZmZhMzdlMmY1NDk3OWJjMmM0NzAwZGE5MTI1YTY"
  };

  const currentCertificates = getCurrentSBACerts(certs);
  const pendingCertificates = getPendingSBACerts(certs);
  const previousCertificates = getPastSBACerts(certs);
  const suspendedCertificates = getSuspendedSBACerts(certs);

  return (
    <div className={styles["profile-certifications-root"]}>
      <h2 className={styles["heading"]} id="certifications" tabIndex={-1}>
        Certifications
      </h2>

      <h6 className={styles["sam-help"]}>
        <DisplayValue
          className={styles["value"]}
          messageElement="p"
          value={certNotShowingInSAM}
          renderer={(_value) => {
            return (
              <>
                <a
                  href={certNotShowingInSAM.link}
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link usa-link--external"
                >
                  {certNotShowingInSAM.display}
                </a>
              </>
            );
          }}
        />
      </h6>

      <div className={styles["group"]}>
        <img src={SBACertBadge} alt="sba certification" />
        <h3 className={styles["sub-heading"]}>SBA certifications</h3>
      </div>

      <div className={styles["list-content"]}>
        {!certs || certs?.length === 0 ? (
          <p className={styles["not-found"]}>
            This firm does not have any active or former SBA certifications
          </p>
        ) : (
          <div className={styles["sba-certs-list"]}>
            {currentCertificates.map((cert, index) => {
              return <SBACertificateCard key={index} {...cert} />;
            })}

            {pendingCertificates.map((cert, index) => {
              return (
                <SBACertificateCard
                  key={index}
                  {...cert}
                />
              );
            })}

            {suspendedCertificates.map((cert, index) => {
              return (
                <SBACertificateCard
                  key={index}
                  {...cert}
                />
              );
            })}

            {previousCertificates.map((cert, index) => {
              return (
                <SBACertificateCard key={index} {...cert} />
              );
            })}
          </div>
        )}
      </div>

      <div className={styles["non-fedral-section"]}>
        <h3 className={styles["sub-heading"]}>
          Non-Federal government certifications
        </h3>
        {non_fed_govt_certifications ? (
          <>
            {
              <ul className={styles["list"]}>
                {non_fed_govt_certifications.split(';').map((cert, i) => (
                  <li key={i}>{cert}</li>
                ))}
              </ul>
            }
          </>
        ) : (
          <p><i>No Non-Federal government certifications provided</i></p>
        )}
      </div>
    </div>
  );
}
